<template>
    <div class="container mt-5">
        <div class="row">
            <div class="col-12 text-center">
                <img class="img mb-4" src="img/logo.png">
            </div>
            <div class="col-12 card-wrap">
                <b-card>
                    <h1 class="text-center">Registruj se</h1>
                    <b-form class="login" @submit.prevent="register" autocomplete="off">
                        <h3></h3>
                        <b-form-group
                                label-for="name">
                            <b-form-input
                                    id="name"
                                    v-model="name"
                                    type="text"
                                    required
                                    placeholder="Jméno"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-for="email">
                            <b-form-input
                                    id="email"
                                    v-model="email"
                                    type="email"
                                    required
                                    placeholder="Email"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-for="tel">
                            <b-form-input
                                    id="tel"
                                    v-model="tel"
                                    type="tel"
                                    placeholder="telefonní číslo xxxxxxxxx"
                                    title="telefonní číslo: 9 čísel bez mezer"
                                    pattern="[0-9]{3}[0-9]{3}[0-9]{3}"
                                    required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-for="password">
                            <b-form-input
                                    id="password"
                                    v-model="password"
                                    type="password"
                                    required
                                    placeholder="Heslo"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                                label-for="password_confirmation">
                            <b-form-input
                                    id="password_confirmation"
                                    v-model="password_confirmation"
                                    type="password"
                                    required
                                    placeholder="Ověření Hesla"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                                label-for="register_key">
                            <b-form-input
                                    id="register_key"
                                    v-model="register_key"
                                    type="password"
                                    required
                                    placeholder="Registrační klíč"
                                    title="uděluje tomas.srb@stroystudio.com"
                            ></b-form-input>
                        </b-form-group>

                        <b-button class="col-12" type="submit" variant="primary">Registrovat</b-button>
                    </b-form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "registration",
        data(){
            return {
                name : "",
                email : "",
                tel : "",
                password : "",
                password_confirmation : "",
                register_key : ""
            }
        },
        methods: {
            register: function () {

                if (this.password === this.password_confirmation)  {
                    let data = {
                        name: this.name,
                        email: this.email,
                        tel: this.tel,
                        password: this.password,
                        register_key: this.register_key
                    }
                    this.$store.dispatch('register', data)
                        .then(() => this.$router.push('/'))
                        .catch(
                            err => {
                                console.log(err);
                                alert('Něco je špatně, zkus napsat na tomas.srb@stroystudio.com');
                            })
                } else {
                    alert('hesla se musí schodovat');
                }


            }
        }
    }
</script>

<style scoped lang="scss">

    .card-wrap {
        display: flex;
        justify-content: center;

        .card {
            width: 100%;
            max-width: 400px;
        }
    }

</style>